import React from "react";
import { Form } from "react-bootstrap";
import { Button, CircularProgress } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import LinkIcon from "@material-ui/icons/Link";
import { SiShopify } from "react-icons/si";
import LeftBorderInputFormik from "../../../components/LeftBorderInputFormik";
import "./register-connect-mobile.scss";

const SHOPIFY_APP_URL =
    "https://apps.shopify.com/emailmarketing_emailwish_abandonedcart_popup_chat_reviews";
const WOOCOMMERCE_PLUGIN_URL = "https://wordpress.org/plugins/emailwish/";

function WooCommerceIcon() {
    return (
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="11" fill="#7F54B3" />
            <text
                x="12"
                y="16.5"
                textAnchor="middle"
                fill="#fff"
                fontSize="13"
                fontWeight="700"
                fontFamily="Arial, sans-serif"
            >
                W
            </text>
        </svg>
    );
}

export type RegisterConnectPlatform = "shopify" | "woocommerce";

export interface RegisterConnectCopy {
    connectPrompt: string;
    appStoreTitle: string;
    appStoreSubtitle: string;
    urlLabel: string;
    urlPlaceholder: string;
    getStarted: string;
    orLabel: string;
}

interface FormikRenderProps {
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
    handleChange: React.ChangeEventHandler<HTMLInputElement>;
    values: { website_url: string };
    isSubmitting: boolean;
}

interface RegisterConnectOptionsProps {
    platform: RegisterConnectPlatform;
    copy: RegisterConnectCopy;
    formik: FormikRenderProps;
    registerCardChildClass: string;
    loginFormGroupClass: string;
    submitClass: string;
}

export default function RegisterConnectOptions({
    platform,
    copy,
    formik,
    registerCardChildClass,
    loginFormGroupClass,
    submitClass,
}: RegisterConnectOptionsProps) {
    const appStoreHref =
        platform === "shopify" ? SHOPIFY_APP_URL : WOOCOMMERCE_PLUGIN_URL;

    return (
        <div className="register-connect">
            <p className="register-connect__prompt">{copy.connectPrompt}</p>

            <div className="ew-dropdown-panel ew-dropdown-panel--drawer-embed register-connect__panel">
                <a
                    href={appStoreHref}
                    className="ew-dropdown-option register-connect__option"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span
                        className={`register-connect__icon register-connect__icon--${
                            platform === "shopify" ? "shopify" : "woocommerce"
                        }`}
                    >
                        {platform === "shopify" ? <SiShopify /> : <WooCommerceIcon />}
                    </span>
                    <span className="register-connect__body">
                        <span className="register-connect__title">{copy.appStoreTitle}</span>
                        <span className="register-connect__subtitle">{copy.appStoreSubtitle}</span>
                    </span>
                    <ChevronRightIcon className="register-connect__chevron register-connect__chevron--primary" />
                </a>
            </div>

            <div className="ew-or-separator" aria-hidden="true">
                <span>{copy.orLabel}</span>
            </div>

            <div className="ew-dropdown-panel ew-dropdown-panel--drawer-embed register-connect__panel">
                <div className="register-connect__url-block">
                    <div className="register-connect__url-header">
                        <span className="register-connect__icon register-connect__icon--link">
                            <LinkIcon fontSize="small" />
                        </span>
                        <span className="register-connect__body">
                            <span className="register-connect__title">{copy.urlLabel}</span>
                        </span>
                        <ChevronRightIcon className="register-connect__chevron register-connect__chevron--muted" />
                    </div>
                    <Form
                        onSubmit={formik.handleSubmit}
                        className={`${registerCardChildClass} register-connect__form app-dashboard-form-chrome`}
                    >
                        <Form.Group className={loginFormGroupClass}>
                            <LeftBorderInputFormik
                                margin="normal"
                                required
                                fullWidth
                                dashboardChrome
                                placeholder={copy.urlPlaceholder}
                                value={formik.values.website_url}
                                name="website_url"
                                dense
                                onChange={formik.handleChange}
                            />
                        </Form.Group>
                        <Button
                            variant="contained"
                            type="submit"
                            fullWidth
                            color="inherit"
                            className={submitClass}
                            disabled={formik.isSubmitting}
                        >
                            {formik.isSubmitting && (
                                <>
                                    <CircularProgress size={15} />
                                    &nbsp;
                                </>
                            )}
                            {copy.getStarted}
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    );
}
